import React from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'
import SkeletonIcon from '../SkeletonIcon'
import SkeletonText from '../SkeletonText'
import styles from './styles'

const SkeletonIconText = ({ size, theme, width, className }) => (
  <div className={cx(styles.wrapper, className)}>
    <SkeletonIcon size={size} theme={theme} />
    <SkeletonText size={size} theme={theme} width={width} />
  </div>
)

SkeletonIconText.propTypes = {
  size: PropTypes.oneOf(['', 'default', 'small']),
  theme: PropTypes.oneOf(['', 'light', 'dark']),
  width: PropTypes.number,
  className: PropTypes.string,
}

SkeletonIconText.defaultProps = {
  size: 'default',
  theme: 'light',
  width: 90,
}

export default SkeletonIconText
